import { useNavigate } from "react-router-dom";

export const AuthCallback = () => {
  const navigate = useNavigate();

  navigate("/login", {
    state: { isSsoRedirect: true },
    replace: true
  });

  return null;
};

export const SilentAuthCallback = () => {
  const navigate = useNavigate();

  navigate("/login", {
    state: { isSsoRedirect: true },
    replace: true
  });

  return null;
};
